/**
 * MIRA Accordion Component
 * Wraps Shadcn Accordion with MIRA design system styles
 */

import React from 'react';
import {
  Accordion as ShadcnAccordion,
  AccordionItem as ShadcnAccordionItem,
  AccordionTrigger as ShadcnAccordionTrigger,
  AccordionContent as ShadcnAccordionContent,
} from '@/components/ui/accordion';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/layout/accordion.module.css';

export const Accordion = ({ children, ...props }) => {
  return <ShadcnAccordion {...props}>{children}</ShadcnAccordion>;
};

export const AccordionItem = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAccordionItem
        ref={ref}
        className={cn(styles.miraAccordionItem, className)}
        {...props}
      />
    );
  }
);

AccordionItem.displayName = 'MiraAccordionItem';

export const AccordionTrigger = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAccordionTrigger
        ref={ref}
        className={cn(styles.miraAccordionTrigger, className)}
        {...props}
      />
    );
  }
);

AccordionTrigger.displayName = 'MiraAccordionTrigger';

export const AccordionContent = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAccordionContent
        ref={ref}
        className={cn(styles.miraAccordionContent, className)}
        {...props}
      />
    );
  }
);

AccordionContent.displayName = 'MiraAccordionContent';
